import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Browser Supabase client.
 *
 * Uses the PUBLISHABLE key only. Row Level Security is what protects the data
 * — this key is designed to be public. If a `sb_secret_` key ever appears
 * here, that is a full database compromise: rotate it immediately.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/** False until `.env` is filled in. The UI explains rather than crashing. */
export const isSupabaseConfigured = Boolean(url && anonKey);

if (import.meta.env.DEV && anonKey?.startsWith('sb_secret_')) {
  throw new Error(
    'VITE_SUPABASE_ANON_KEY holds a SECRET key. That key bypasses every ' +
      'security policy and must never reach a browser. Rotate it in Supabase ' +
      'now, then use the PUBLISHABLE key here.',
  );
}

export const supabase: SupabaseClient = createClient(url ?? 'http://localhost', anonKey ?? 'anon', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The session lives in localStorage. Fine for a web app; the mobile app
    // in Phase 10 uses secure storage instead.
    storageKey: 'mmp.auth',
    detectSessionInUrl: false, // we use typed codes, not magic links
  },
});
